export abstract class MailboxService {
    abstract initialize(): void;
    abstract destroyEventHandler(): void;
}
